import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  addToCart,
  removeFromCompare,
  loadDeepData,
} from '../actions/wishCompareCart';
import { withTranslation } from 'react-i18next';
import Footer from './footer';
import UIkit from 'uikit';
import loader from '../images/loader.svg';
import deleteIcon from '../images/delete-icon.svg';
import cartIcon from '../images/cart-icon.svg';
import { Link } from 'react-router-dom';
import i18n from 'i18next';
import { Helmet } from 'react-helmet';

/**
 * Just a wrapper under list items
 *
 */
class Comparelist extends Component {
  static propTypes = {
    compareDeepData: PropTypes.array,
    compareData: PropTypes.array,
    isShowCompareCartWishLoader: PropTypes.bool,
  };

  constructor() {
    super();
    this.state = { filters: [] };
  }

  componentDidMount() {
    this.props.loadDeepData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isChangeUrl) {
      this.props.history.replace(this.props.urlForChange);
      window.scrollTo(0, 0);
    }

    const filters = [];

    if (
      this.props.compareDeepData[0] !== undefined &&
      Object.keys(this.props.compareDeepData[0].deepGoodsData).length > 0
    ) {
      Object.keys(this.props.compareDeepData[0].deepGoodsData).map(
        (inxCategory) => {
          filters[inxCategory] = [];
          Object.keys(
            this.props.compareDeepData[0].deepGoodsData[inxCategory]
          ).map((inx) => {
            Object.keys(
              this.props.compareDeepData[0].deepGoodsData[inxCategory][inx]
            ).map((inx_) => {
              Object.keys(
                this.props.compareDeepData[0].deepGoodsData[inxCategory][inx][
                  inx_
                ]
              ).map((key_num) => {
                if (
                  filters[inxCategory].indexOf(
                    this.props.compareDeepData[0].deepGoodsData[inxCategory][
                      inx
                    ][inx_][key_num].nameFilter
                  ) === -1
                ) {
                  if (
                    this.props.compareDeepData[0].deepGoodsData[inxCategory][
                      inx
                    ][inx_][key_num].nameFilter !== 'Ціна'
                  )
                    filters[inxCategory].push(
                      this.props.compareDeepData[0].deepGoodsData[inxCategory][
                        inx
                      ][inx_][key_num].nameFilter
                    );
                }
              });
            });
          });
          filters[inxCategory].push('Ціна');
        }
      );
    }
    if (prevProps.compareDeepData[0] != this.props.compareDeepData[0]) {
      this.setState({ filters: filters });
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div className='uk-container'>
        <header>
          <Helmet>
            <meta charSet='utf-8' />
            <title>{t('compare')}</title>
          </Helmet>
        </header>
        {
          <div
            className={
              this.props.isShowCompareCartWishLoader ? '' : 'uk-hidden'
            }
          >
            <div className='loader-overlay uk-position-cover uk-position-z-index'>
              <div className='uk-position-center'>
                <img
                  className='loader-img'
                  src={loader}
                  uk-svg={''}
                  alt={'loading...'}
                />
              </div>
            </div>
          </div>
        }
        <div className='uk-margin-top'>
          <h1 className='page-title uk-text-bold'>{t('compare')}</h1>
        </div>
        <div>
          {Object.keys(this.state.filters).map((category) => (
            <div className='uk-margin uk-overflow-auto'>
              {category !== 'all' && (
                <h4 className='uk-text-bold'>{category}</h4>
              )}
              <table className='compare-table'>
                <tbody>
                  <tr>
                    <th>{t('table.name')}</th>
                    {this.props.compareDeepData[0].deepGoodsData[category] !==
                      undefined &&
                      Object.keys(
                        this.props.compareDeepData[0].deepGoodsData[category]
                      ).map((name) => {
                        const item = Object.keys(
                          this.props.compareDeepData[0].deepGoodsData[category][
                            name
                          ]
                        )[0].split(' ');

                        return (
                          <td>
                            <Link
                              className='uk-link-heading uk-text-bold'
                              to={
                                `/products/${i18n.language + '/' + item[0]}` +
                                '/item/' +
                                item[1]
                              }
                              title={name}
                            >
                              {name}
                            </Link>
                          </td>
                        );
                      })}
                  </tr>
                  {this.state.filters[category].map((itm) => (
                    <tr className={itm === 'Ціна' && 'active'}>
                      <th>{itm === 'Ціна' ? <b>{itm}</b> : itm}</th>
                      {this.props.compareDeepData[0].deepGoodsData[category] !==
                        undefined &&
                        Object.keys(
                          this.props.compareDeepData[0].deepGoodsData[category]
                        ).map((name) =>
                          Object.keys(
                            this.props.compareDeepData[0].deepGoodsData[
                              category
                            ][name]
                          ).map((id) => (
                            <>
                              <td>
                                {Object.keys(
                                  this.props.compareDeepData[0].deepGoodsData[
                                    category
                                  ][name][id]
                                ).map(
                                  (inx) =>
                                    this.props.compareDeepData[0].deepGoodsData[
                                      category
                                    ][name][id][inx]['nameFilter'] == itm &&
                                    (itm !== 'Ціна' ? (
                                      <>
                                        {
                                          this.props.compareDeepData[0]
                                            .deepGoodsData[category][name][id][
                                            inx
                                          ]['valueFilter']
                                        }
                                      </>
                                    ) : (
                                      <b>
                                        {
                                          this.props.compareDeepData[0]
                                            .deepGoodsData[category][name][id][
                                            inx
                                          ]['valueFilter']
                                        }{' '}
                                        грн
                                      </b>
                                    ))
                                )}
                              </td>
                            </>
                          ))
                        )}
                    </tr>
                  ))}

                  <tr>
                    <th></th>
                    {this.props.compareDeepData[0].deepGoodsData[category] !==
                      undefined &&
                      Object.keys(
                        this.props.compareDeepData[0].deepGoodsData[category]
                      ).map((name) => (
                        <td>
                          {Object.keys(
                            this.props.compareDeepData[0].deepGoodsData[
                              category
                            ][name]
                          ).map((keyData) => {
                            const id = keyData.split(' ');

                            return (
                              <>
                                <div>
                                  <button
                                    onClick={(e) => this.props.addToCart(id[1])}
                                    className={'product-addtocart uk-button'}
                                    title={t('item.add_tocart')}
                                  >
                                    {t('item.add_tocart')}
                                  </button>
                                </div>
                                <div className='uk-margin-small-top'>
                                  <button
                                    onClick={(e) =>
                                      this.props.removeFromCompare(
                                        id[1],
                                        name,
                                        t('wishlist.msgShureRemove'),
                                        t('wishlist.msgYes'),
                                        t('wishlist.msgNo')
                                      )
                                    }
                                    className='compare-list__remove-btn  uk-button '
                                  >
                                    {t('item.remove')}
                                  </button>
                                </div>
                              </>
                            );
                          })}
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </div>
          ))}

          {this.props.compareDeepData[0] !== undefined
            ? Object.keys(this.props.compareDeepData[0].deepGoodsData).length >
              0
              ? Object.keys(this.props.compareDeepData[0].deepGoodsData).map(
                  (itm) => (
                    <div className='uk-margin' hidden={true}>
                      <h4 className='uk-text-bold'>{itm}</h4>

                      <div
                        className='uk-position-relative'
                        tabIndex='-1'
                        uk-slider=''
                        hidden={true}
                      >
                        <ul className='uk-slider-items uk-grid-match  uk-child-width-1-2@s uk-child-width-1-3@m uk-grid'>
                          {Object.keys(
                            this.props.compareDeepData[0].deepGoodsData[itm]
                          ).map((nameGood) => (
                            <li>
                              <div className='product-card uk-card uk-card-small'>
                                <div className='uk-card-media-top uk-text-center uk-padding'>
                                  <span> {nameGood} </span>
                                </div>

                                {Object.keys(
                                  this.props.compareDeepData[0].deepGoodsData[
                                    itm
                                  ][nameGood]
                                ).map((keyData) => (
                                  <div className='uk-card-body'>
                                    <ul className='uk-list uk-text-small  uk-margin-bottom'>
                                      {Object.keys(
                                        this.props.compareDeepData[0]
                                          .deepGoodsData[itm][nameGood][keyData]
                                      ).map((filterData) => (
                                        <li className='uk-flex uk-flex-between uk-flex-top uk-child-width-1-2'>
                                          <span className='uk-text-bold'>
                                            {
                                              this.props.compareDeepData[0]
                                                .deepGoodsData[itm][nameGood][
                                                keyData
                                              ][filterData]['nameFilter']
                                            }
                                          </span>
                                          <span>
                                            {
                                              this.props.compareDeepData[0]
                                                .deepGoodsData[itm][nameGood][
                                                keyData
                                              ][filterData]['valueFilter']
                                            }
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}
                                <div className={'uk-card-footer uk-width-1-1'}>
                                  {Object.keys(
                                    this.props.compareDeepData[0].deepGoodsData[
                                      itm
                                    ][nameGood]
                                  ).map((keyData) => {
                                    const id = keyData.split(' ');
                                    return (
                                      <div className='uk-text-center'>
                                        <div
                                          onClick={(e) =>
                                            this.props.addToCart(id[1])
                                          }
                                          className={
                                            'product-addtocart uk-button'
                                          }
                                          title={t('item.add_tocart')}
                                        >
                                          {t('item.add_tocart')}
                                        </div>
                                        <div
                                          onClick={(e) =>
                                            this.props.removeFromCompare(
                                              id[1],
                                              nameGood,
                                              t('wishlist.msgShureRemove'),
                                              t('wishlist.msgYes'),
                                              t('wishlist.msgNo')
                                            )
                                          }
                                          className='compare-list__remove-btn uk-position-top-right uk-padding-small'
                                        >
                                          <img
                                            src={deleteIcon}
                                            uk-svg={''}
                                            alt={t('item.remove_from_cart')}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                        <a
                          class='uk-position-center-left uk-position-small'
                          href='#'
                          uk-slidenav-previous=''
                          uk-slider-item='previous'
                        ></a>
                        <a
                          class='uk-position-center-right uk-position-small'
                          href='#'
                          uk-slidenav-next=''
                          uk-slider-item='next'
                        ></a>
                      </div>

                      {Object.keys(
                        this.props.compareDeepData[0].deepGoodsData[itm]
                      ).map((nameGood, index) => (
                        <>
                          <div
                            className={
                              'uk-card-footer uk-padding-remove uk-width-1-1 uk-hidden'
                            }
                          >
                            {Object.keys(
                              this.props.compareDeepData[0].deepGoodsData[itm][
                                nameGood
                              ]
                            ).map((keyData) => (
                              <div>
                                <div
                                  onClick={(e) => this.props.addToCart(keyData)}
                                  className={
                                    'card-footer-btn uk-flex uk-flex-middle uk-flex-center'
                                  }
                                  title={t('item.add_tocart')}
                                >
                                  <img
                                    className='card-footer-btn_img'
                                    src={cartIcon}
                                    uk-svg=''
                                    alt={t('item.add_tocart')}
                                  />
                                </div>
                                <div
                                  onClick={(e) =>
                                    this.props.removeFromCompare(
                                      keyData,
                                      nameGood,
                                      t('wishlist.msgShureRemove'),
                                      t('wishlist.msgYes'),
                                      t('wishlist.msgNo')
                                    )
                                  }
                                  className='compare-list__remove-btn uk-position-top-right'
                                >
                                  <img
                                    src={deleteIcon}
                                    uk-svg={''}
                                    alt={t('item.remove_from_cart')}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ))}
                    </div>
                  )
                )
              : t('wishlist.no_data_found')
            : t('compare')}
        </div>
      </div>
    );
  }
}

const ProductsComparelist = withTranslation('translations')(Comparelist);

const mapStateToProps = (store) => {
  const { isShowCompareCartWishLoader, compareDeepData, compareData } =
    store.wishCompareCart;
  const { urlForChange, isChangeUrl } = store.goods;

  return {
    isShowCompareCartWishLoader,
    compareDeepData: compareDeepData,
    compareData,
    urlForChange,
    isChangeUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (id) => {
      dispatch(addToCart(id, false));
    },
    loadDeepData: () => {
      dispatch(loadDeepData());
    },
    removeFromCompare: (id, itemName, msgShureRemove, msgYes, msgNo) => {
      UIkit.modal
        .confirm(
          '<p class="uk-text-emphasis">' +
            msgShureRemove +
            ` ${itemName}` +
            '</p>',
          { labels: { ok: msgYes, cancel: msgNo } }
        )
        .then(function () {
          dispatch(removeFromCompare(id));
          dispatch(loadDeepData());
        });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsComparelist);
